import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';

@jsonObject
export class AdminBoxSaleGroupCosmeticRequest {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(Number)
  public readonly amount?: Nillable<number>;

  @jsonMember(Number)
  public readonly availableQuantity?: Nillable<number>;

  public constructor(
    private readonly data: {
      amount?: Nillable<number>;
      availableQuantity?: Nillable<number>;
      id: Guid;
    },
  ) {
    this.id = this.data.id;
    this.amount = this.data.amount;
    this.availableQuantity = this.data.availableQuantity;
  }
}
